<template>
    <main class="relative">
        <div
            class="relative mx-auto max-w-[1540px] overflow-x-hidden sm:overflow-y-hidden 2xl:px-[100px]"
        >
            <div
                class="absolute right-[7px] top-[7px] z-[1] hidden justify-center lg:flex 2xl:right-[107px]"
            >
                <img
                    width="500"
                    height="500"
                    src="https://zaptime.s3.eu-central-1.amazonaws.com/application-assets/base-glass.png"
                    alt=""
                />
            </div>
            <div
                class="absolute right-[-220px] top-[-40px] flex justify-center 2xl:right-[-110px]"
            >
                <GradientBackground></GradientBackground>
            </div>

            <ConfirmDialog></ConfirmDialog>
            <ProDialog></ProDialog>
            <div class="bg-[#F4F4F5] sm:grid sm:grid-cols-[248px_1fr]">
                <!-- Left Navigation Menu -->
                <nav class="z-40 hidden sm:block">
                    <div class="px-6">
                        <div class="flex h-screen flex-col justify-between">
                            <div>
                                <!-- Logo -->
                                <div
                                    class="mt-[38px] flex flex-shrink-0 items-center"
                                >
                                    <Link :href="route('app.dashboard')">
                                        <jet-application-mark
                                            class="block h-9 w-auto"
                                        />
                                    </Link>
                                </div>

                                <!-- Navigation Links -->
                                <div class="mt-10">
                                    <Link
                                        :class="[
                                            'mb-4 inline-flex h-10 w-[200px] items-center gap-2 rounded-lg pl-3 text-[15px] font-medium hover:bg-iron-200',
                                            isBookingsActive
                                                ? 'bg-iron-200 text-iron-700  '
                                                : 'text-iron-500',
                                        ]"
                                        :href="route('app.dashboard')"
                                    >
                                        <BookingsIcon />
                                        {{ $t("nav.bookings") }}
                                    </Link>

                                    <Link
                                        :class="[
                                            'mb-4 inline-flex h-10 w-[200px] items-center gap-2 rounded-lg pl-3 text-[15px] font-medium hover:bg-iron-200',
                                            route().current(
                                                'app.event-types.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="route('app.event-types.index')"
                                    >
                                        <EventsIcon />
                                        {{ $t("nav.event_types") }}
                                    </Link>

                                    <Link
                                        :class="[
                                            'mb-4 inline-flex h-10 w-[200px] items-center gap-2 rounded-lg pl-3 text-[15px] font-medium hover:bg-iron-200',
                                            route().current(
                                                'app.appearances.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="route('app.appearances.index')"
                                    >
                                        <AppearanceIcon />
                                        {{ $t("nav.appearances") }}
                                    </Link>

                                    <Link
                                        :class="[
                                            'mb-4 inline-flex h-10 w-[200px] items-center gap-2 rounded-lg pl-3 text-[15px] font-medium hover:bg-iron-200',
                                            route().current(
                                                'app.availabilities.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="
                                            route('app.availabilities.index')
                                        "
                                    >
                                        <Clock :size="20" stroke-width="2.2" />
                                        {{ $t("nav.availability") }}
                                    </Link>

                                    <Link
                                        :class="[
                                            'mb-4 inline-flex h-10 w-[200px] items-center gap-2 rounded-lg pl-3 text-[15px] font-medium hover:bg-iron-200',
                                            route().current(
                                                'app.workflows.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="route('app.workflows.index')"
                                    >
                                        <Waypoints :size="20" />
                                        {{ $t("nav.workflows") }}
                                    </Link>

                                    <Link
                                        v-if="firstTeamId !== null"
                                        :class="[
                                            'mb-4 inline-flex h-10 w-[200px] items-center gap-2 rounded-lg pl-3 text-[15px] font-medium hover:bg-iron-200',
                                            route().current(
                                                'app.teams.reports.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="
                                            route('app.teams.reports.index', {
                                                team: firstTeamId,
                                            })
                                        "
                                    >
                                        <ChartArea :size="20" />
                                        {{ $t("nav.team_reports") }}
                                    </Link>

                                    <Link
                                        v-if="page.props.pendingInvitation"
                                        class="inline-flex h-10 w-[200px] cursor-pointer items-center gap-2 rounded-lg pl-3 text-xs font-medium text-iron-500 hover:bg-iron-200"
                                        :href="route('app.teams.index')"
                                    >
                                        <div
                                            class="flex items-center justify-center"
                                        >
                                            <span
                                                class="h-2 w-2 rounded bg-purple-500"
                                            ></span>
                                            <span
                                                class="absolute h-2 w-2 animate-ping rounded bg-purple-500"
                                            ></span>
                                        </div>
                                        {{ $t("teams.pending") }}
                                    </Link>
                                </div>
                            </div>

                            <div class="pb-[30px]">
                                <ProfileSettingsDropdown></ProfileSettingsDropdown>
                            </div>
                        </div>
                    </div>
                </nav>

                <!-- Page Content -->

                <main
                    class="page-content relative z-20 mr-0 mt-1.5 rounded-t-xl sm:mr-4 sm:mt-4"
                >
                    <div
                        class="flex h-[64px] items-center gap-2 rounded-t-xl border-b bg-white px-4 sm:h-[88px] sm:gap-4 sm:px-6"
                    >
                        <div>
                            <slot name="icon"></slot>
                        </div>
                        <div class="grow">
                            <h1
                                class="text-lg font-semibold leading-6 tracking-tight text-iron-900 sm:text-xl"
                            >
                                <slot name="title"></slot>
                            </h1>
                            <p class="hidden text-sm text-iron-500 sm:block">
                                <slot name="description"></slot>
                            </p>
                        </div>
                        <div
                            class="flex items-center justify-end gap-3 sm:justify-center"
                        >
                            <slot name="actions"></slot>
                        </div>
                    </div>

                    <!-- <div
                        class="items-center gap-4 rounded-t-xl border-b bg-white px-4 sm:hidden"
                    >
                        <div>
                            <slot name="icon"></slot>
                        </div>
                        <div class="grow">
                            <h1
                                class="text-lg font-semibold leading-6 tracking-tight text-iron-900 sm:text-xl"
                            >
                                <slot name="title"></slot>
                            </h1>
                            <p class="text-sm text-iron-500">
                                <slot name="description"></slot>
                            </p>
                        </div>
                        <div
                            class="flex items-center justify-end gap-3 sm:justify-center"
                        >
                            <slot name="actions"></slot>
                        </div>
                    </div> -->
                    <div class="bg-iron-25">
                        <ScrollArea
                            class="h-[calc(100vh-164px)] sm:h-[calc(100vh-120px)]"
                        >
                            <slot></slot>
                        </ScrollArea>
                    </div>
                </main>

                <!-- Mobile Bottom fixed Menu -->
                <div
                    class="fixed bottom-0 left-0 z-50 flex w-full items-center border-t border-iron-200 bg-white px-4 py-4 sm:hidden"
                >
                    <ProfileSettingsDropdown></ProfileSettingsDropdown>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup lang="ts">
import JetApplicationMark from "../Jetstream/ApplicationMark.vue";
import ProfileSettingsDropdown from "./components/ProfileSettingsDropdown.vue";
import ConfirmDialog from "../Pages/ZapTime/App/ConfirmDialog/components/ConfirmDialog.vue";
import route from "ziggy-js";
import { Link, usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import GradientBackground from "./GradientBackgroud.vue";
import BookingsIcon from "./components/BookingsIcon.vue";
import EventsIcon from "./components/EventsIcon.vue";
import AppearanceIcon from "@/Layouts/components/AppearanceIcon.vue";

import { ScrollArea } from "@/components/ui/scroll-area";

import { Waypoints, Clock, ChartArea } from "lucide-vue-next";
import ProDialog from "@/ProModal/components/ProDialog.vue";

const isBookingsActive = computed(() => {
    return (
        route().current("app.dashboard") ||
        route().current("app.dashboard.upcoming") ||
        route().current("app.dashboard.cancelled") ||
        route().current("app.dashboard.past")
    );
});

type SharedData = {
    pendingInvitation: boolean;
};
const page = usePage<SharedData>();

const firstTeamId = computed(() => {
    // @ts-expect-error
    const currentUserId = page.props.user.id;

    console.log(page.props.allTeams);

    // @ts-expect-error
    const ownedTeams = page.props.allTeams.filter((team) => {
        return team.owner?.id === currentUserId;
    });

    let teamId: number | null = null;

    for (const team of ownedTeams) {
        if (!team.personal_team) {
            teamId = team.id;
            break;
        }
    }

    return teamId;
});
</script>

<style>
.page-content {
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    border-right: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0px 0px 10px rgba(16, 24, 40, 0.08);
}
</style>
